import { RadioButtonDesignTokens } from '@primeuix/themes/types/radiobutton';

export const ezRadioButtonThemeConfig: RadioButtonDesignTokens = {
  colorScheme: {
    light: {
      root: {
        checkedBackground: '#167007',
        checkedBorderColor: '#167007',
        checkedHoverBackground: '#1C850A',
      },
    },
  },
};
